<div class="line {{color}}" [style.height.px]="thickness"></div>
